
import { defineComponent } from "vue"
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { spatialOmicsApi } from "@/request";
import { CommonCategory } from "@/types/Request";
import type { TabsPaneContext } from "element-plus";
import GeneExpression from "@/components/GeneExpression.vue"
import GeneColorView from "@/components/GeneColorView.vue"
import GeneAttributeView from "@/components/GeneAttributeView.vue"
import GeneExpressionCompare from "@/components/GeneExpressionCompare.vue"
import { ElMessageBox } from 'element-plus'

export default defineComponent({
  data () {
    return {
      dataset: {},
      dataList: [],
      data: {},
      selectedDataID: null,
      geneTypeList: [],
      allGeneTypeList: [],
      selectedGeneType: '',
      geneImage: '',
      activeName: 'geneExpression',
      router: useRouter(),
      store: useStore()
    }
  },
  components: {
    GeneAttributeView,
    GeneExpression,
    GeneColorView,
    GeneExpressionCompare
  },
  computed: {
    /**
     * 获取当前dataset id，用于更新DatasetView组件
     */
    selectedDatasetID () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return this.store.state.selectedDatasetID
    }
  },
  methods: {
    /**
     * 根据dataset id获取对应的dataset，并将data设置为其data列表第一个data，将gene类型设置为其data基因列表的第一个基因
     * @param datasetID
     */
    getDataset (datasetID: number) {
      console.log('getDataset', datasetID)
      spatialOmicsApi.getDatasetByDatasetID(datasetID).then(async (res) => {
        console.log('res', res)
        this.dataset = res.data
        this.dataList = res.data.data
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        console.log('dataset', this.dataList[0].id)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.selectedDataID = this.dataList[0].id
        await this.dataChangeCallback()
      })
    },

    /**
     * 根据当前下拉列表选择的data更新data信息
     */
    async dataChangeCallback () {
      this.activeName = 'geneExpression'
      await this.$nextTick()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      await spatialOmicsApi.getDataByDataID(this.selectedDataID).then(async (res) => {
        console.log('data res', res)
        this.data = res.data
        console.log('data', this.data)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$refs.gene.setData(this.data)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$refs.gene.geneFeatureChangeCallBack()
      })
    },

    /**
     * 切换tab的回调函数
     * @param tab tab名称
     */
    async handleClick (tab: TabsPaneContext) {
      console.log("handleClick", tab.paneName, this.data)
      await this.$nextTick()
      if (tab.paneName === 'geneExpression') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (this.$refs.gene.getDataId() !== this.data.id) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.$refs.gene.setData(this.data)
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.$refs.gene.geneFeatureChangeCallBack()
          console.log("geneExpression get data complete")
        }
      } else if (tab.paneName === 'geneColorView') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (this.$refs.geneColorView.getDataId() !== this.data.id) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.$refs.geneColorView.setData(this.data)
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.$refs.geneColorView.getGeneColorViewData()
          console.log("getGeneColorViewData get data complete")
        }
      } else if (tab.paneName === 'geneAttributeView') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (this.$refs.geneAttributeView.getDataId() !== this.data.id) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.$refs.geneAttributeView.setData(this.data)
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.$refs.geneAttributeView.getGeneAttributeViewData()
          console.log("geneAttributeView get data complete")
        }
      } else if (tab.paneName === 'geneExpressionCompare') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (this.$refs.geneExpressionCompare.getDataId() !== this.data.id) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.$refs.geneExpressionCompare.setData(this.data)
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.$refs.geneExpressionCompare.geneFeatureChangeCallBack()
          console.log("geneExpressionCompare get data complete")
        }
      }
    },
    download_fake() {
      ElMessageBox.alert('This work is under review, please email jianhuayao at tencent.com for inquiring the downloading support. This download button will be activated upon publication', '', )      
    },
    //download事件处理
    download() {
      console.log(this.dataset, this.selectedDataID)
      console.log(`${location.origin}/SpatialOmics/api/download_data/`+this.selectedDataID)
      // ElMessageBox.alert('This work is under review, please email jianhuayao at tencent.com for inquiring the downloading support. This download button will be activated upon publication', '', )      
      // window.open(`${location.origin}/SpatialOmics/api/data/`+this.selectedDataID)
      let a = document.createElement("a");
      a.href = `${location.origin}/SpatialOmics/api/download_data/`+this.selectedDataID;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // a.download = this.dataset.biotech + "_" + this.dataset.name_short + "_" + this.selectedDataID + '.h5'; // 对比与window下载，特点在于可以设置下载下来的文件名
      a.click();
      // spatialOmicsApi.download_data(this.selectedDataID).then(async (res) => {
      //   console.log('res', res, this.dataset)
      //   let data = res.origin;
      //   const blob = new Blob([data])
      //   let link = document.createElement('a')
      //   link.href = window.URL.createObjectURL(blob)
      //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //   // @ts-ignore
      //   link.download = this.dataset.access + '.h5'
      //   link.click()
      // })
    }
  },
  mounted() {
    console.log('----------route----------', this.$route.query)
    // eslint-disable-next-line no-prototype-builtins
    if (this.$route.query.hasOwnProperty('datasetID')) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.getDataset(this.$route.query['datasetID'])
    }else{
      console.log('dataset view mount not get dataset')
    }
  },
  watch: {
    selectedDatasetID (newVal, oldVal) {
      console.log('watch', newVal, oldVal)
      this.getDataset(newVal)
    }
  }
})
